import React, { Component } from "react";
import { Icon, Spinner } from "@blueprintjs/core";
import dayjs from "dayjs";
import { BASE_API } from "../../utils/constants";
import SaveBar from "../../components-fm/SaveBar";

import TrainingInfoGeneral from "./TrainingInfoGeneral";
import TrainingInfoPlayers from "./TrainingInfoPlayers";
import "./../../css/EventsDetails.scss";

export default class TrainingDetails extends Component {
    state = {
        expandedSections: new Set(["general", "players"]),
        training: null,
        players: [],
        originalTraining: null,
        originalPlayers: [],
        loading: true,
        error: null,
        isModified: false,
    };

    async componentDidMount() {
        const wrapper = document.getElementById('echipaDashboard');
        if (wrapper) wrapper.classList.add('layout-full-width', "dark-view");

        const { action, event_id, team_id } = this.getUrlParams();
        if (action === "edit" && event_id) {
            try {
                const trainingRes = await fetch(`${BASE_API}/api/event/${event_id}`);
                const trainingData = await trainingRes.json();

                if (trainingData?.event?.event_type === "training") {
                    // const trainingId = event_id; gresit
                    const playersRes = await fetch(`${BASE_API}/api/training/${event_id}/players`);
                    const players = (await playersRes.json())?.players ?? [];

                    this.setState({
                        training: trainingData.event,
                        originalTraining: trainingData.event,
                        players,
                        originalPlayers: players,
                        loading: false
                    });
                } else {
                    this.setState({ error: "Evenimentul nu este un antrenament", loading: false });
                }
            } catch (err) {
                this.setState({ error: err.message, loading: false });
            }
        } else if (action === "add" && team_id) {
            const today = new Date().toISOString().slice(0, 10);
            const draft = {
                event_date: today,
                event_time: "17:00",
                training_type: "",
                description: "",
                location: "",
                training_duration: 90,
                training_name: "",
                team_id
            };

            const playersRes = await fetch(`${BASE_API}/api/team-players/${team_id}`);
            const players = (await playersRes.json())?.players ?? [];

            // Setăm status implicit pentru Add
            const enriched = players.map(p => ({ ...p, status: (p.status || "active"), position: null }));

            this.setState({
                training: draft,
                originalTraining: draft,
                players: enriched,
                originalPlayers: enriched,
                loading: false
            });
        } else {
            this.setState({ error: "Parametri lipsă sau invalizi", loading: false });
        }
    }

    componentWillUnmount() {
        const wrapper = document.getElementById('echipaDashboard');
        if (wrapper) wrapper.classList.remove('layout-full-width', "dark-view");
    }

    getUrlParams = () => {
        const search = this.props.location?.search || window.location.search;
        const urlParams = new URLSearchParams(search);
        return {
            action: urlParams.get("action"),
            event_id: urlParams.get("event_id"),
            team_id: urlParams.get("team_id"),
        };
    };

    checkIfModified = () => {
        const { training, originalTraining, players, originalPlayers } = this.state;
        const tChanged = JSON.stringify(training) !== JSON.stringify(originalTraining);
        const pChanged = JSON.stringify(players) !== JSON.stringify(originalPlayers);
        this.setState({ isModified: tChanged || pChanged });
    };

    handleTrainingChange = (fields) => {
        this.setState(prev => ({ training: { ...prev.training, ...fields } }), this.checkIfModified);
    };

    handlePlayerStatusChange = (playerId, status) => {
        const players = this.state.players.map(p => p.id === playerId ? { ...p, status } : p);
        this.setState({ players }, this.checkIfModified);
    };

    handleSave = async () => {
        const { training, players } = this.state;
        const { action } = this.getUrlParams();
        const payload = {
            type: "training",
            team_id: training.team_id,
            name: training.training_name,
            date: training.event_date,
            time_start: training.event_time,
            location: training.location,
            training_type: training.training_type,
            description: training.description,
            training_duration: training.training_duration,
            players: players.map(p => ({
                id: p.id,
                training_position: p.position || null,
                status: p.status || null
            }))
            // players: players.map(p => p.id)
        };

        const res = await fetch(
            action === "edit"
                ? `${BASE_API}/api/events/${training.event_id}`
                : `${BASE_API}/api/events`,
            {
                method: action === "edit" ? "PATCH" : "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            }
        );

        const result = await res.json();
        if (res.ok) {
            alert("Salvat cu succes");
            this.setState({
                originalTraining: training,
                originalPlayers: players,
                isModified: false
            });
        } else {
            alert(result.error || "Eroare la salvare");
        }
    };

    toggleSection = (key) => {
        this.setState((prev) => {
            const next = new Set(prev.expandedSections);
            next.has(key) ? next.delete(key) : next.add(key);
            return { expandedSections: next };
        });
    };

    render() {
        console.log(this.state)
        const { training, players, loading, error, expandedSections, isModified } = this.state;
        const { team_id, action } = this.getUrlParams();

        if (loading) return <Spinner />;
        if (error) return <div className="error bp5-text-danger">{error}</div>;

        return (
            <div className="event-card">
                <header className="card-header">
                    <h2>
                        {training
                            ? `Antrenament – ${dayjs(training.event_date).format("D MMM YYYY")} / ${training.event_time || "–"}`
                            : "Antrenament"}
                    </h2>
                </header>

                <div className="event-sections">
                    <div className="section">
                        <div className="section-header" onClick={() => this.toggleSection("general")}>
                            <Icon icon={expandedSections.has("general") ? "chevron-down" : "chevron-right"} />
                            <span>Informații</span>
                        </div>
                        <div className="section-body">
                            {expandedSections.has("general") && (
                                <TrainingInfoGeneral
                                    training={training}
                                    onChange={this.handleTrainingChange}
                                />
                            )}
                        </div>
                    </div>

                    <div className="section" style={{"height": 'calc(100vh - 257px)'}}>
                        <div className="section-header" onClick={() => this.toggleSection("players")}>
                            <Icon icon={expandedSections.has("players") ? "chevron-down" : "chevron-right"} />
                            <span>Jucători</span>
                        </div>
                        <div className="section-body">
                            {expandedSections.has("players") && (
                                <TrainingInfoPlayers
                                    players={players}
                                    onStatusChange={this.handlePlayerStatusChange}
                                    training={training}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <SaveBar
                    visible={isModified}
                    onSave={this.handleSave}
                    onCancel={() => this.setState({ training: this.state.originalTraining, players: this.state.originalPlayers, isModified: false })}
                />
            </div>
        );
    }
}
